<template>
  <div v-if="isLoading || stats">
    <div v-if="isLoading" class="home-page__widgets">
      <div class="widget data-waiting-animation-dark"></div>
      <div class="widget data-waiting-animation-dark"></div>
      <div class="widget data-waiting-animation-dark"></div>
      <div class="widget data-waiting-animation-dark"></div>
    </div>
    <div v-else-if="stats" class="home-page__widgets">
      <awaiting-confirmation-widget
        v-if="!!stats.WaitingForConfirmationBookingStats"
        :model="stats.WaitingForConfirmationBookingStats"
      />
      <awaiting-payment-widget
        v-if="!!stats.WaitingForPaymentBookingStats"
        :model="stats.WaitingForPaymentBookingStats"
      />
      <awaiting-activation-widget
        v-if="!!stats.PreBookingStats"
        :model="stats.PreBookingStats"
      />
      <starts-soon-widget
        v-if="!!stats.TourStartTodayBookingStats || !!stats.TourStartTomorrow || !!stats.TourStartAfterTomorrow"
        :today="stats.TourStartTodayBookingStats"
        :tomorrow="stats.TourStartTomorrow"
        :after-tomorrow="stats.TourStartAfterTomorrow"
      />
    </div>
  </div>
</template>

<script setup>
import AwaitingActivationWidget from "./AwaitingActivationWidgetComponentDesktop.vue";
import StartsSoonWidget from "./StartsSoonWidgetComponentDesktop.vue";
import AwaitingConfirmationWidget from "./AwaitingConfirmationWidgetComponentDesktop.vue";
import AwaitingPaymentWidget from "./AwaitingPaymentWidgetComponentDesktop.vue";
import {onMounted, ref} from "vue";
import { post } from "@/common/fetch";

const isLoading = ref(true);
const stats = ref(null);

const fetchStats = async () => {
  const response = await post("/Home/GetBookingStats", {}, true);
  if (response.IsSucceeded) {
    stats.value = response;
  }
  isLoading.value = false;    
}

onMounted(() => {
  fetchStats();
})
</script>

<style lang="scss" scoped>
@use "./widget";

.home-page__widgets {
  display: flex;
  flex-flow: row nowrap;
  gap: 24px;

  > * {
    flex: 0 0 auto;
  }
}
</style>



